var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetHelpForum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15V1C0 .717.096.48.287.287A.968.968 0 0 1 1 0h13c.283 0 .52.096.713.287.191.192.287.43.287.713v9c0 .283-.096.52-.287.713A.968.968 0 0 1 14 11H4l-4 4Zm5 1a.967.967 0 0 1-.713-.287A.968.968 0 0 1 4 15v-2h13V4h2c.283 0 .52.096.712.287.192.192.288.43.288.713v15l-4-4H5Zm8-14H2v8.175L3.175 9H13V2Z",
    fill: "#2F42C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetHelpForum);
export default __webpack_public_path__ + "static/media/getHelp_forum.a239fa4bd5b1ce2b5fddc4ba711bcfdd.svg";
export { ForwardRef as ReactComponent };